export default __webpack_public_path__ + "static/media/whitepaper_eng.8cb8d7f3.pdf";